import Layout from "@/components/Layout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ExternalLink } from "lucide-react";

interface Partner {
  url: string;
  anchorText: string;
  description?: string;
}

const partners: Partner[] = [
  {
    url: "https://www.lifetimemovers.us",
    anchorText: "LifeTime Movers Chicago",
    description: "Serving Lenexa, Overland Park, Shawnee, and the Kansas City metro.",
  },
];

const LinkPartners = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative py-16 bg-gradient-to-br from-primary/10 via-secondary/5 to-accent/10">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            Link Partners
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Trusted businesses we proudly partner with in our community.
          </p>
        </div>
      </section>

      {/* Partners List */}
      <section className="py-16 bg-background">
        <div className="container mx-auto px-4 max-w-3xl">
          <Card>
            <CardHeader>
              <CardTitle className="text-xl text-foreground">Our Partners</CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-6">
                {partners.map((partner, index) => (
                  <li key={index} className="border-b border-border pb-4 last:border-b-0 last:pb-0">
                    <a
                      href={partner.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-secondary hover:text-secondary/80 font-medium transition-colors"
                    >
                      {partner.anchorText}
                      <ExternalLink className="h-4 w-4" />
                    </a>
                    {partner.description && (
                      <p className="text-sm text-muted-foreground mt-1">
                        {partner.description}
                      </p>
                    )}
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        </div>
      </section>
    </Layout>
  );
};

export default LinkPartners;
